import { ApiResponse, ApisauceInstance } from 'apisauce'
import { handleResponse } from '../handleResponse'

export const SettingsApi = {
  apisauce: {} as ApisauceInstance,

  /**
   * Get mimetype list
   */
  getMimeTypes: async () => {
    const response: ApiResponse<any> = await SettingsApi.apisauce.get(`/settings/mimetypes/`)
    return handleResponse(response)
  },
}
